import { createContext, useContext, useEffect, useState } from "react";
import { buscarTramite } from "../api/Tramite";
import Loader from "../components/controls/Loader";
import { useAuthentication } from "./Authentication";

const TramiteContext = createContext(null);

export function useTramite() {
  return useContext(TramiteContext);
}

export default function TramiteProvider({ numero, children, ...props }) {
  const { token } = useAuthentication();
  const [tramite, setTramite] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    buscarTramite(numero, token)
      .then((tramite) => {
        setTramite(tramite);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  }, [numero, token]);
  return (
    <Loader loading={loading && !tramite}>
      <TramiteContext.Provider value={{ tramite, setTramite }}>
        {children}
      </TramiteContext.Provider>
    </Loader>
  );
}
